import clone from 'fast-copy';
import equals from 'fast-deep-equal';
import { Model } from '../Model.js';

var _dec, _class;

/**
 * Plain object ShipmentService representation.
 *
 */

/**
 * Serialized object ShipmentService representation.
 *
 */

/**
 * Plain object Packlink's API POST payload representation.
 *
 */

/**
 * Plain object Packlink's API POST payload representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let ShipmentService = (_dec = Model(), _dec(_class = class ShipmentService {
  /**
   * Takes a IShipmentServiceApiResponse from Packlink's API and returns a ShipmentService.
   *
   * @param response  IShipmentServiceApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    const {
      service_info
    } = response;
    return new ShipmentService(response.carrier || undefined, response.service_id ? parseInt(response.service_id, 10) : undefined, response.service || undefined, service_info && service_info.is_drop_off_in_destination !== null && service_info.is_drop_off_in_origin !== null ? {
      destination: service_info === null || service_info === void 0 ? void 0 : service_info.is_drop_off_in_destination,
      origin: service_info === null || service_info === void 0 ? void 0 : service_info.is_drop_off_in_origin
    } : undefined, (service_info === null || service_info === void 0 ? void 0 : service_info.is_own_contract) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.is_own_contract, (service_info === null || service_info === void 0 ? void 0 : service_info.carrier_product_id) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.carrier_product_id, (service_info === null || service_info === void 0 ? void 0 : service_info.tracking_url) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.tracking_url, (service_info === null || service_info === void 0 ? void 0 : service_info.has_paperless_customs) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.has_paperless_customs, (service_info === null || service_info === void 0 ? void 0 : service_info.has_print_in_store) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.has_print_in_store, (service_info === null || service_info === void 0 ? void 0 : service_info.print_in_store_url) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.print_in_store_url, (service_info === null || service_info === void 0 ? void 0 : service_info.print_in_store_default) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.print_in_store_default, (service_info === null || service_info === void 0 ? void 0 : service_info.logo_id) === null ? undefined : service_info === null || service_info === void 0 ? void 0 : service_info.logo_id);
  }

  /**
   * Takes a serialized ShipmentService and returns a ShipmentService.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentService.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentService.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentService.
   *
   */

  /**
   * Takes a serialized ShipmentService and returns a ShipmentService.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentService.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentService.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentService.
   *
   */

  /**
   * Takes a serialized ShipmentService and returns a ShipmentService.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentService.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentService.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentService.
   *
   */

  /**
   * Takes a serialized ShipmentService and returns a ShipmentService.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized ShipmentService.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedShipmentService.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of ShipmentService.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new ShipmentService(data.carrierName, data.id, data.name, clone(data.dropOff), data.isOwnContract, data.carrierProductId, data.trackingUrl, data.hasPaperlessCustoms, data.hasPrintInStore, data.printInStoreUrl, data.printInStoreDefault, data.logoId);
  }

  /**
   * Returns a new ShipmentService. Typings of the properties depend on the class type param T
   *
   */
  constructor(carrierName, id, name, dropOff, isOwnContract, carrierProductId, trackingUrl, hasPaperlessCustoms, hasPrintInStore, printInStoreUrl, printInStoreDefault, logoId) {
    this.carrierName = carrierName;
    this.id = id;
    this.name = name;
    this.dropOff = dropOff;
    this.isOwnContract = isOwnContract;
    this.carrierProductId = carrierProductId;
    this.trackingUrl = trackingUrl;
    this.hasPaperlessCustoms = hasPaperlessCustoms;
    this.hasPrintInStore = hasPrintInStore;
    this.printInStoreUrl = printInStoreUrl;
    this.printInStoreDefault = printInStoreDefault;
    this.logoId = logoId;
  }

  /**
   * Returns a JSON serialized version of the ShipmentService.
   *
   */
  toJSON() {
    return {
      carrierName: this.carrierName,
      id: this.id,
      name: this.name,
      dropOff: this.dropOff,
      isOwnContract: this.isOwnContract,
      carrierProductId: this.carrierProductId,
      trackingUrl: this.trackingUrl,
      hasPaperlessCustoms: this.hasPaperlessCustoms,
      hasPrintInStore: this.hasPrintInStore,
      printInStoreUrl: this.printInStoreUrl,
      printInStoreDefault: this.printInStoreDefault,
      logoId: this.logoId
    };
  }

  /**
   * Returns a clone of the ShipmentService.
   *
   */
  clone() {
    return new ShipmentService(this.carrierName, this.id, this.name, clone(this.dropOff), this.isOwnContract, this.carrierProductId, this.trackingUrl, this.hasPaperlessCustoms, this.hasPrintInStore, this.printInStoreUrl, this.printInStoreDefault, this.logoId);
  }

  /**
   * Returns whether the two ShipmentService are equal.
   *
   */
  equals(shipmentService) {
    if (!shipmentService) {
      return false;
    }
    return this.carrierName === shipmentService.carrierName && this.id === shipmentService.id && this.name === shipmentService.name && equals(this.dropOff, shipmentService.dropOff) && this.isOwnContract === shipmentService.isOwnContract && this.carrierProductId === shipmentService.carrierProductId && this.trackingUrl === shipmentService.trackingUrl && this.hasPaperlessCustoms === shipmentService.hasPaperlessCustoms && this.hasPrintInStore === shipmentService.hasPrintInStore && this.printInStoreUrl === shipmentService.printInStoreUrl && this.printInStoreDefault === shipmentService.printInStoreDefault && this.logoId === shipmentService.logoId;
  }

  /**
   * Returns a JSON with the payload necessary to create a ShipmentService.
   *
   */
  getCreatePayload() {
    return {
      carrier: this.carrierName,
      service: this.name,
      service_id: this.id
    };
  }
}) || _class);

export { ShipmentService };
//# sourceMappingURL=ShipmentService.js.map
